import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "Core/Theme";

export const useM365PulseInfoRowsStyles = makeStyles({
    root: {
        fontSize: themeTokens.fontSizeBase300,
        lineHeight: themeTokens.lineHeightBase500
    }
});
